// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3xLNG","label":"SetPasswdForm_label__1Wss_"};